/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateTemplateRequest {
    getFixupPrototypeFunction() { return CreateTemplateRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateTemplateRequest>): CreateTemplateRequest {
        let obj = Object.assign(new CreateTemplateRequest(), model);
        CreateTemplateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateTemplateRequest>): CreateTemplateRequest {
        if (!model) return null;
        return CreateTemplateRequest.newInstance(<CreateTemplateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateTemplateRequest) {
        if (!obj) return;

        models.CreateTemplateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateTemplateRequest): boolean {
        Object.setPrototypeOf(obj, CreateTemplateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metadata) {
            models.MetaDataModel.fixupPrototype(this.metadata);
        }
    }

    /**
     * template name which is unique and does not allow special character or space
     */
    name: string;

    /**
     * Usage of the template.
     */
    description: string;

    /**
     * The template content
     */
    content: string;

    /**
     * Metadata like file name, file format
     */
    metadata: models.MetaDataModel;

    /**
     * Status of the template [active/inactive]. active:- Templates which can be executed. inactive:- Template which cannot be executed
     */
    status: string;

    /**
     * Templates are classified based orchestration actions like Provision, Configure, Backup, Catalog Builder, Deployment, Autoscaling
     */
    classification: Array<string>;

    /**
     * The scope of the template: Global Scope - All users will have access to view and execute CoreStack Marketplace templates; will not have access to update/delete them, Account scope - All users under that account will have access to view and execute Only Account admins can update/delete the templates, Tenant Scope - Users with access to the specific tenant will have access to templates who can describe or execute templates. Tenant admins can only update/delete. Private Scope - User who created will only have access
     */
    scope: models.AccountScope;

    /**
     * Type of the template (Cloud, Monitoring, Virtualization)
     */
    type: Array<string>;

    /**
     * Displays the service associated with the template, for example, AWS, AzureRM, Openstack., etc
     */
    services: Array<string>;

    /**
     * Template formats such as AWS CFN, Azure ARM, Openstack Heat and Mistral
     */
    engine_type: models.TemplateEngineType;

    /**
     * Flag to add template to blueprints
     */
    blueprint_support: boolean;

}
